export const CONTACT_SEARCH_LIMIT = 10;
export const CONTACT_SEARCH_DEBOUNCE_MS = 250;

/**
 * Map a contact API result to a compose suggestion item.
 */
export const mapContactToSuggestion = (contact) => ({
  ...contact,
  suggestionType: 'contact',
  username: contact.displayName || contact.email,
  profileImage: contact.avatar || contact.profileImage || '',
});

/**
 * Map a group API result to a compose suggestion item.
 */
export const mapGroupToSuggestion = (group) => ({
  ...group,
  suggestionType: 'group',
});

/**
 * Client-side filter for groups by name (groups stay separate from contacts).
 */
export const filterGroupsByQuery = (groups, query) => {
  const normalized = String(query || '').trim().toLowerCase();
  if (!normalized) return [];
  return (groups || []).filter((group) =>
    String(group.name || '').toLowerCase().includes(normalized)
  );
};
